import BaseService from "@/services/BaseService";
import Category from "@/types/Category";

export default class CategoryService extends BaseService {
    static async getCategories(host: string, organizationId: string | null) {
        let url = "/portal/categories?host=" + host;
        if (organizationId)
            url += "&organizationId=" + organizationId;
        return await this.perform<Category[]>({
            url: url,
            method: "GET",
            auth: true
        });
    }
}